import "./FleetLoggerElement.less"
import { SwitchButtonElement } from '../Forms/SwitchButtonElement';
import { FleetLoggerStore, CollectRequest } from './FleetLoggerStore'; 
import { GoogleMapsHelper } from "../GoogleMaps/GoogleMapsHelper";


export class FleetLoggerElement extends HTMLElement { 
    static tag = "fleet-logger";
    private _switchButton: SwitchButtonElement; 
    private _nameElement: HTMLInputElement;
    private _statusElement: HTMLElement;
    private _phoneNumberElement: HTMLInputElement;
    private _initialsElement: HTMLInputElement;
    private _deviceId: string;
    private _passwordElement: HTMLInputElement;
    private _password: string;
    private _passwordChanged = false;

    connectedCallback() { 
        this.innerHTML = this.view();
        this._switchButton = this.querySelector(SwitchButtonElement.tag);
        this._switchButton.addEventListener("change", this.toggleLogger);
        this._nameElement = this.querySelector("[name=name]") as HTMLInputElement;
        this._phoneNumberElement = this.querySelector("[name=phone-number]") as HTMLInputElement;
        this._initialsElement = this.querySelector("[name=initials]") as HTMLInputElement;
        this._statusElement = this.querySelector("[name=status]") as HTMLElement;
        this._passwordElement = this.querySelector("[name=password]") as HTMLInputElement;
        this._passwordElement.addEventListener("input", this.onChangePassword);

        try {
            this._nameElement.value = localStorage.getItem("fleet-logger-name") || "";
            this._phoneNumberElement.value = localStorage.getItem("fleet-logger-phone-number") || "";
            this._initialsElement.value = localStorage.getItem("fleet-logger-initials") || "";
            this._deviceId = localStorage.getItem("fleet-logger-device-id");
            this._password = localStorage.getItem("fleet-password") || "";

            if (this._password?.length > 0)
                this._passwordElement.value = "(password set)";    

        } catch (e) {
            console.log("Unable to read from local storage " + e);
        }

        if (!this._deviceId || this._deviceId === "") { 
            this._deviceId = this.generateDeviceId();

            console.log("Device id is ", this._deviceId);

            try { 
                localStorage.setItem("fleet-logger-device-id", this._deviceId);
            }
            catch (e) {
                console.log("Unable to save to local storage " + e);
            }
        }

      
    }

    private onChangePassword = async () => { 
        this._passwordChanged = true;
    }   

    generateDeviceId(): string {
        // generate a 10 letter random string
        let result = "";
        const characters = "abcdefghijklmnopqrstuvwxyz";
        for (let i = 0; i < 10; i++) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return result;
    }

    disconnectedCallback() { 
        this._switchButton.removeEventListener("change", this.toggleLogger);
    }

    private toggleLogger = async () => { 
        if (this._nameElement.value === "" || !this._nameElement.validity.valid) { 
            this._nameElement.reportValidity();
            this._switchButton.toggleAttribute("checked", false);
            return;
        }

        if (this._phoneNumberElement.value === "" || !this._phoneNumberElement.validity.valid) { 
            this._phoneNumberElement.reportValidity();
            this._switchButton.toggleAttribute("checked", false);
            return;
        }

        if (this._initialsElement.value === "" || !this._initialsElement.validity.valid) { 
            this._initialsElement.reportValidity();
            this._switchButton.toggleAttribute("checked", false);
            return;
        }

        

        if (this.hasAttribute("running")) { 
            FleetLoggerStore.instance.stop();
            this.removeAttribute("running");

            this._statusElement.innerText = "Not tracking location";
            return;
        }

        FleetLoggerStore.instance.start();

        try {
            localStorage.setItem("fleet-logger-name", this._nameElement.value);
            localStorage.setItem("fleet-logger-initials", this._initialsElement.value);
            localStorage.setItem("fleet-logger-phone-number", this._phoneNumberElement.value);

            if (this._passwordChanged) { 
                this._password = await this.createPassword(this._passwordElement.value, this._initialsElement.value);
                this._passwordChanged = false;
                localStorage.setItem("fleet-password", this._password);
                this._passwordElement.value = "(password set)";    
            }            
        } catch (e) {
            console.log("Unable to write to localstorage " + e);
        }

        FleetLoggerStore.instance.deviceDetails = {
            deviceId: this._deviceId,
            name: this._nameElement.value,
            phoneNumber: this._phoneNumberElement.value,
            initials: this._initialsElement.value.toUpperCase()
        };
        
        this.toggleAttribute("running", true);
        this._statusElement.innerText = "Tracking location";
    }

    private createPassword = async (password: string, initials: string) => { 
        const passwordHash = await this.createHash(password.toLowerCase());
        return await this.createHash(passwordHash + initials.toLowerCase());
    }

    private createHash = async (text: string) => {
        // encode as UTF-8
        const msgBuffer = new TextEncoder().encode(text);

        // hash the message
        const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

        // convert ArrayBuffer to Array
        const hashArray = Array.from(new Uint8Array(hashBuffer));

        // convert bytes to hex string                  
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
        return hashHex;
    }

    view = () => `
        <div>
            <${SwitchButtonElement.tag}></${SwitchButtonElement.tag}>
            <div name=status>Not tracking location</div>
            
            <label>Route name
                <input type="text" placeholder="Tour X" name=name required pattern="Tour [A-Z]" />
            </label>

            <label>Initials
                <input type="text" placeholder="XX" name=initials maxlength=3 required />
            </label>

            <label>Phone number
                <input type="text" placeholder="XXXXXXXX" name=phone-number maxlength=8 pattern="[0-9]*" minlength=8 required />
            </label>

            <label>Password
                <input type="text" placeholder="" name=password />
            </label>

            <a
            target=_blank
            class=home-link
            href="https://www.google.com/maps/dir/?api=1&destination=M%C3%B8nstedsvej+8%2C+Silkeborg&travelmode=driving&dir_action=navigate">
                <div>Eurowheels HQ</div>
                 <div>${require("../../Images/google-maps.svg")} Google Maps</div>
        </div>
    `;
}

customElements.define(FleetLoggerElement.tag, FleetLoggerElement);